"use strict";

define('components/subscription',['components/form', 'components/ajax', 'components/utils',
        'components/progress_modal', 'components/payment_pref'],
       function(formComponent, ajax, utils, progress_modal, paymentPrefComponent) {

    var subscriptionComponent = {

        init: function() {
            var basicInfo = $('#subscription-basic-info');
            if (basicInfo.length == 1) {
                subscriptionComponent._initBasicInfo(basicInfo);
                return;
            }

            var details = $('#subscription-subscriber-details');
            if (details.length == 1) {
                subscriptionComponent._initSubscriberDetails(details);
                return;
            }

            var contacts = $('#subscription-contacts');
            if (contacts.length == 1) {
                subscriptionComponent._initContacts(contacts);
                return;
            }
        },

        _initBasicInfo: function(basicInfo) {
            // Update subscription $ amount if the settings was to show units
            subscriptionComponent._setTotalCommitment(basicInfo);
            $('#number-of-units').keyup(function(e){
                subscriptionComponent._setTotalCommitment(basicInfo);
            });

            // Reveal the 'new account info' section if user selects the
            // 'Create a new investor account' option.
            $('input[type=radio][name=account_id]').change(function(e) {
                subscriptionComponent._updateAccountInfo(basicInfo, $(this).data('account-info'));

                // Clear out any prior errors
                $('#account_id .has-error').removeClass('has-error');
                $('#subscription-basic-info .has-error').removeClass('has-error');
            });

            // Update the form based on the selected account type
            $('input[type=radio][name=account_type]').change(function(e) {
                var accountType = $(this).val();
                subscriptionComponent._updateAccountTypeFields(basicInfo, accountType);
            });

            $('input[type=radio][name=account_type]').click(function(e) {
                // Check if account type changed on existing account, if so legal name fields should never be readonly.
                // Also use eventPhase to see change in account type was triggered by a user click and not by 
                // _setOrClearBasicInfoRadioButton.
                var accountInfo = basicInfo.find('input[type=radio][name=account_id]:checked').data('account-info');
                if (e.eventPhase == 2 && accountInfo && accountInfo['account_name']) {
                    var accountNameInput = basicInfo.find('input[name=account_name]');
                    var firstNameInput = basicInfo.find('input[id=subscriber_first_name]');
                    var middleNameInput = basicInfo.find('input[id=subscriber_middle_name]');
                    var lastNameInput = basicInfo.find('input[id=subscriber_last_name]');
                    subscriptionComponent._disableOrEnableLegalNameFields(
                        firstNameInput, middleNameInput, lastNameInput, accountNameInput, false
                    );
                    var accountTypeChangedInput = basicInfo.find('input[name=account_type_changed]');
                    accountTypeChangedInput.val(true);
                }
            });

            // Show/hide JurisdictionState based on Jurisdiction country
            $('.jurisdiction .jurisdiction-country').change(function(e) {
                var jurisdictionCountry;
                if (e.added && e.added.text) {
                    jurisdictionCountry = e.added.text;
                }
                if (jurisdictionCountry == 'United States') {
                    $('.jurisdiction .jurisdiction-state').removeClass('hidden');
                } else {
                    $('.jurisdiction .jurisdiction-state').addClass('hidden');
                }
            });

            $('a#continue').click(function(e){
                e.preventDefault();
                e.stopPropagation();
                subscriptionComponent._saveBasicInfo(basicInfo);
            });

            subscriptionComponent._initErrorHandler(basicInfo);
        },

        _updateAccountInfo: function(basicInfo, accountInfo) {
            // Reveal the account type selector form on account select
            basicInfo.find('.account-type-selector').removeClass('hidden');

            // Update labels of fields to match the selected account type
            subscriptionComponent._updateAccountTypeFields(basicInfo,
                'account_type' in accountInfo ? accountInfo['account_type'] : null);
            subscriptionComponent._setOrClearBasicInfoRadioButton(accountInfo, 'account_type');
            var accountNameInput = basicInfo.find('input[name=account_name]');
            accountNameInput.val(accountInfo['account_name']);
            basicInfo.find('input[name=tax_id]').val(accountInfo['tax_id']);

            // Set or clear the address fields
            subscriptionComponent._setMailingAddress(basicInfo.find('.mailing-address'),
                                                     accountInfo['mailing_address']);
            subscriptionComponent._setMailingAddress(basicInfo.find('.domicile-address'),
                                                     accountInfo['domicile_address']);
            subscriptionComponent._setDisregardedEntityFields(basicInfo, accountInfo);
            subscriptionComponent._setOrClearSameDomicileCheckBox(accountInfo);
            if (accountInfo['same_domicile_address']) {
                basicInfo.find('.domicile-address-field').addClass('hidden');
            } else {
                basicInfo.find('.domicile-address-field').removeClass('hidden');
            }

            // Set or clear the is_us_person radio button
            subscriptionComponent._setOrClearBasicInfoRadioButton(accountInfo, 'is_us_person');

            subscriptionComponent._setBasicInfoContacts(basicInfo.find('.joint-owners'), accountInfo);
            subscriptionComponent._setBasicInfoContacts(basicInfo.find('.counterparties'), accountInfo);
            var firstNameInput = basicInfo.find('input[id=subscriber_first_name]');
            var middleNameInput = basicInfo.find('input[id=subscriber_middle_name]');
            var lastNameInput = basicInfo.find('input[id=subscriber_last_name]');
            var accountTypeChangedInput = basicInfo.find('input[name=account_type_changed]');
            if (accountTypeChangedInput.val() == 'false') {
                var isReadOnly = accountInfo['account_name'] !== undefined;
                subscriptionComponent._disableOrEnableLegalNameFields(
                    firstNameInput, middleNameInput, lastNameInput, accountNameInput, isReadOnly
                );
            }
        },

        _updateAccountTypeFields: function(basicInfo, accountType) {
            if (accountType) {
                $('#subscription-basic-info .account-info').removeClass('hidden');
            }

            // Update the form to show the form fields appropriate for the selected account type.
            var  taxIDLabels = basicInfo.data('tax-id-labels'),
                 individualAccountTypes = basicInfo.data('individual-account-types'),
                 jointAccountTypes = basicInfo.data('joint-account-types'),
                 trustAccountTypes = basicInfo.data('trust-account-types'),
                 entityAccountTypes = basicInfo.data('entity-account-types'),
                 formationDateLabel = basicInfo.data('formation-date-label'),
                 formationDocType = basicInfo.data('formation-doc-type'),
                 contactsLabel = basicInfo.data('contacts-label');

            // Show the right subscriber name field based on accountType
            basicInfo.find('.subscriber-data, .counterparties, .joint-owners').addClass('hidden');
            var activeSubscriberDataSection = null;
            if (accountType == null || individualAccountTypes.indexOf(accountType) >= 0) {
                activeSubscriberDataSection = basicInfo.find('.subscriber-data-individual');
            } else if (jointAccountTypes.indexOf(accountType) >= 0) {
                activeSubscriberDataSection = basicInfo.find('.subscriber-data-joint');
                basicInfo.find('.joint-owners').removeClass('hidden');
                var jointLabelText = basicInfo.find('.joint-account-label-text').text();
                if (accountType == "Joint"){
                    basicInfo.find('.joint-account-label-text').text(jointLabelText.replace("entity", 'account'));
                }
                else {
                    basicInfo.find('.joint-account-label-text').text(jointLabelText.replace('account', "entity"));
                }
            } else if (trustAccountTypes.indexOf(accountType) >= 0) {
                activeSubscriberDataSection = basicInfo.find('.subscriber-data-trust');
                basicInfo.find('.counterparties').removeClass('hidden');
            } else {
                activeSubscriberDataSection = basicInfo.find('.subscriber-data-entity');
                if (accountType == 'Partnership') {
                    basicInfo.find('.erisa-questions').addClass('hidden');
                } else {
                    basicInfo.find('.erisa-questions').removeClass('hidden');
                }
                basicInfo.find('.counterparties').removeClass('hidden');
            }
            activeSubscriberDataSection.removeClass('hidden');

            // Update TaxID label
            $('.tax-id label').text(taxIDLabels[accountType]);

            // Show the domicile address if the account type supports it
            if (accountType != null && entityAccountTypes.indexOf(accountType) == -1 &&
                individualAccountTypes.indexOf(accountType) == -1 &&
                trustAccountTypes.indexOf(accountType) == -1) {
                $('.domicile-address').addClass('hidden');
            } else {
                var sameDomicileAddress = activeSubscriberDataSection.find('input[type=checkbox][name=same_domicile_address]').prop('checked');
                $('.domicile-address').removeClass('hidden');
                if (!sameDomicileAddress) {
                    $('.domicile-address-field').removeClass('hidden')
                }
            }

            // Update formation date label
            if (formationDateLabel[accountType]) {
                $('.formation-date').removeClass('hidden')
                                    .find('label')
                                    .text(formationDateLabel[accountType]);
            } else {
                $('.formation-date').addClass('hidden');
            }

            // Update formation document type
            if (formationDocType[accountType]) {
                $('.formation-doc-msg').removeClass('hidden')
                                       .find('.formation-doc-type')
                                       .text(formationDocType[accountType]);
            } else {
                $('.formation-doc-msg').addClass('hidden');
            }

            // Show all of the trust fields if the account type is trust
            if (accountType == 'Trust') {
                $('.trust').removeClass('hidden');
            } else {
                $('.trust').addClass('hidden');
            }

            // Show the contacts if the account type supports it
            if (contactsLabel[accountType]){
                $('.counterparties-label').html(contactsLabel[accountType])
            } else {
                $('.counterparties-label').html('');
            }
        },

        _setOrClearBasicInfoRadioButton: function(accountInfo, radioInputName) {
            var radioSelector = '#subscription-basic-info input[name=' + radioInputName + ']';
            if (accountInfo[radioInputName]) {
                // Click instead of setting checked prop since there may be behavior on the radio select.
                // For example, the 'account_type=Other' option removes the 'disabled' attribute on
                // the account type text input on click.
                $(radioSelector + '[value=' + accountInfo[radioInputName] + ']').click();
            } else {
                // Default to 'Individual' on no selection
                $(radioSelector + '[value=Individual]').prop('checked', true);
            }
        },

        _setOrClearSameDomicileCheckBox: function(accountInfo) {
            var name = 'same_domicile_address';
            var selector = '#subscription-basic-info input:checkbox[name=' + name + ']';
            if (name in accountInfo && accountInfo[name]) {
                if (!$(selector).prop('checked')) {
                    $(selector).click();
                }
            } else if ($(selector).prop('checked')) {
                $(selector).click();
            }
        },

        _setTotalCommitment: function(basicInfo) {
            var numberOfUnits = basicInfo.find('#number-of-units');
            if (numberOfUnits.length == 0) {
                return;
            }

            var totalCommitment = basicInfo.find('#total-commitment');
            // NOTE: Need to remove any characters that would trip up parseInt,
            // such as ','
            var unitCount = numberOfUnits.val().replace(/,/g, '')
            if (unitCount) {
                totalCommitment.text(utils.formatCurrency(parseFloat(unitCount) * numberOfUnits.data('unit-price'),
                                                          numberOfUnits.data('currency')));
            } else {
                totalCommitment.text('$');
            }
        },

        _saveBasicInfo: function(basicInfo) {
            // Drop DOM elements of entity types the user is not submitting to avoid validating data that doesn't matter
            $('.subscriber-data.hidden').remove();
            var saveButton = basicInfo.find('button#continue');
            var url = saveButton.data('url');
            var formNode = basicInfo.find('form');
            var formData = formComponent.serialize(formNode);
            ajax(url, {
                formData: formData,
                onSuccess: function(result) {
                },
                onFailure: function(result) {
                    basicInfo.replaceWith(result.body)
                    subscriptionComponent._initErrorHandler(basicInfo);
                    require(['components/dom_setup'], function(domSetup) {
                        basicInfo = $('#subscription-basic-info');
                        domSetup.init(basicInfo);
                        subscriptionComponent._initBasicInfo(basicInfo);
                        formComponent.scrollToFirstError(basicInfo);
                    });
                },
            });
        },

        _initSubscriberDetails: function(details) {

            paymentPrefComponent.init(details);

            $('#page-body .question_choice input[value="-1"]').change(function() {
                $(this).closest('.question').find('input[type="checkbox"][value!="-1"]').prop('checked', false);
            });

            $('#page-body .question_choice input[type="checkbox"][value!="-1"]').change(function() {
                $(this).closest('.question').find('input[value="-1"]').prop('checked', false);
            });

            $('#page-body a#continue').one('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                // clear out any partially-completed payment info to avoid validating that which does not apply
                var payment_pref = $('input[name="payment_method"]:checked').val();

                if (payment_pref == 'ACH') {
                    $('input[name^="wire_"]').val("");
                    $('input[name="payment_pref_check"]').val("account_mailing_address");
                } else if (payment_pref == 'Wire') {
                    $('input[name^="ach_"]').val("");
                    $('input[name="payment_pref_check"]').val("account_mailing_address");

                } else if (payment_pref == 'Check') {
                    $('input[name^="wire_"]').val("");
                    $('input[name^="ach_"]').val("");

                }

                var url = $(this).data('url');
                var formNode = details.find('form');
                var formData = formComponent.serialize(formNode);
                ajax(url, {
                    formData: formData,
                    onFailure: function(result) {
                        details.replaceWith(result.body)
                        subscriptionComponent._initErrorHandler(details);
                        require(['components/dom_setup'], function(domSetup) {
                            details = $('#subscription-subscriber-details');
                            domSetup.init(details);
                            subscriptionComponent._initSubscriberDetails(details);
                            formComponent.scrollToFirstError(details);
                        });
                    },
                });
            });

            subscriptionComponent._initErrorHandler(details);
        },

        _initContacts: function(contacts) {
            $('a#continue').click(function(e){
                e.preventDefault();
                e.stopPropagation();

                var saveButton = contacts.find('button#continue');
                var url = saveButton.data('url');
                var formData = new FormData(contacts.find('form')[0]);
                ajax(url, {
                    formData: formData,
                    onSuccess: function(result) {
                    },
                    onFailure: function(result) {
                        contacts.replaceWith(result.body)
                        require(['components/dom_setup'], function(domSetup) {
                            contacts = $('#subscription-contacts');
                            domSetup.init(contacts);
                            subscriptionComponent._initContacts(contacts);
                            subscriptionComponent._initErrorHandler(contacts);
                            formComponent.scrollToFirstError(contacts);
                        });
                    },
                });
            });

            $('input.all-comms').click(function(e) {
                var classToCheck = $(this).data("oid");
                $('.' + classToCheck).each(function() {
                    $(this).prop('checked', true);
                })
            });

            subscriptionComponent._initErrorHandler(contacts);
        },

        _initErrorHandler: function(subscriptionStep) {
            // Clear any field errors on change
            subscriptionStep.find('input').on('change keyup', function(e) {
                var errorField = $(this).closest('.form-group.has-error, .has-error');
                if (errorField) {
                    errorField.removeClass('has-error')
                              .find('.field-error')
                              .remove();
                }
            });
        },

        _setDisregardedEntityFields: function(basicInfo, accountInfo) {
            if (accountInfo['disregarded_entity']) {
                var disregardedRadioButton = basicInfo.find('.disregarded-entity-true');
                disregardedRadioButton.prop('checked', true);
                basicInfo.find('.disregarded-entity-tax-info').removeClass('hidden');

                basicInfo.find('input[name="disregarded_entity_ultimate_beneficial_owner"]')
                    .val(accountInfo['disregarded_entity_ultimate_beneficial_owner']);
                basicInfo.find('input[name="disregarded_entity_tax_id"]')
                    .val(accountInfo['disregarded_entity_ultimate_beneficial_owner_tax_id']);
            } else {
                basicInfo.find('.disregarded-entity-false').prop('checked', true)
                basicInfo.find('.disregarded-entity-tax-info').addClass('hidden');
            }

        },

        _setMailingAddress: function(addressField, address) {
            if (address === null || typeof(address) === 'undefined') {
                address = {
                    'street': null,
                    'street2': null,
                    'street3': null,
                    'city': null,
                    'postal_code': null,
                    'state': {
                        'object_name': null,
                        'object_id': null
                    },
                    'country': {
                        'object_name': null,
                        'object_id': null
                    },
                }
            }
            addressField.find('input[name=street]').val(address['street']);
            addressField.find('input[name=street2]').val(address['street2']);
            addressField.find('input[name=street3]').val(address['street3']);
            addressField.find('input[name=city]').val(address['city']);
            addressField.find('input[name=postal_code]').val(address['postal_code']);
            addressField.find('.state input[name=object_name_input]').val(address['state']['object_name']);
            addressField.find('.state input[name=object_name]').val(address['state']['object_name']);
            addressField.find('.state input[name=object_id]').val(address['state']['object_id']);
            addressField.find('.country input[name=object_name_input]').val(address['country']['object_name']);
            addressField.find('.country input[name=object_name]').val(address['country']['object_name']);
            addressField.find('.country input[name=object_id]').val(address['country']['object_id']);
        },

        _setBasicInfoContacts: function(contactsSection, accountInfo) {
            var contacts = accountInfo['contacts'] || [];
            var contactsSectionItems = contactsSection.find('.deform-seq .deform-seq-item');
            var contactsSectionSize = contactsSectionItems.length;
            if (contacts.length == 0) {
                // Remove all contacts if the selected account type has none
                for (var i=contactsSectionSize - 1; i >= 0; i--) {
                    contactsSectionItems[i].remove();
                }
            } else if (contactsSectionSize < contacts.length) {
                // Add additional contacts to the section until we have enough
                var addButton = contactsSection.find('.deform-seq a.deform-seq-add');
                for (var i=contactsSectionSize; i < contacts.length; i++) {
                    formComponent.appendSequenceItem(addButton);
                }
            } else if (contactsSectionSize > contacts.length) {
                // Remove excess contacts sections from the end of the list
                for (var i=contactsSectionSize - 1; i>contacts.length; i--) {
                    contactsSectionItems[i].remove();
                }
            }

            contactsSectionItems = contactsSection.find('.deform-seq .deform-seq-item');
            for (var i=0; i < contacts.length; i++) {
                var contactItem = $(contactsSectionItems[i]);
                contactItem.find('input[name=first_name]').val(contacts[i]['person_name']['first_name']);
                contactItem.find('input[name=middle_name]').val(contacts[i]['person_name']['middle_name']);
                contactItem.find('input[name=last_name]').val(contacts[i]['person_name']['last_name']);
                contactItem.find('input[name=email_address]').val(contacts[i]['email_address']);
                contactItem.find('input[name=phone_number]').val(contacts[i]['phone_number']);
                if (contacts[i]['address']) {
                    subscriptionComponent._setMailingAddress(contactItem.find('.mailing_address'), contacts[i]['address']);
                } else {
                    subscriptionComponent._setMailingAddress(contactItem.find('.mailing_address'), null);
                }
            }
        },
        _disableOrEnableLegalNameFields: function(firstNameInput, middleNameInput, lastNameInput, accountNameInput, isReadOnly) {
            // Enable and disable legal name fields depending on whether existing account has been chosen.
            accountNameInput.prop('readonly', isReadOnly);
            firstNameInput.prop('readonly', isReadOnly);
            middleNameInput.prop('readonly', isReadOnly);
            lastNameInput.prop('readonly', isReadOnly);
        },
    };

    return subscriptionComponent;
});

